import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initializeFacebookPixel } from './utils/facebookPixel';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

// Initialize Facebook Pixel after DOM is ready
setTimeout(() => {
    initializeFacebookPixel();
}, 100);

root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
